import { Routes, Route } from 'react-router-dom';
import Layout from '../components/layout/Layout';
import UserList from '../pages/users/UserList';
import UserDetails from '../pages/users/UserDetails';
import Dashboard from '../pages/dashboard/Dashboard';
import DiscountList from '../pages/discounts/DiscountList';
import MigrationDashboard from '../pages/MigrationDashboard';

export default function AdminRoutes() {
  return (
    <Routes>
      {/* تمام روت‌ها بدون نیاز به لاگین در Layout نمایش داده می‌شوند */}
      <Route element={<Layout />}>
        <Route path="/" element={<Dashboard />} />
        <Route path="/users" element={<UserList />} />
        <Route path="/users/:userId" element={<UserDetails />} />
        <Route path="/discounts" element={<DiscountList />} />
        <Route path="/migrationdashboard" element={<MigrationDashboard />} />
      </Route>
    </Routes>
  );
}
